module.exports = __webpack_public_path__ + "static/Tungsten-Semibold-caa9a24de6ce0c13284ad120e35b1059.woff2";